export default __webpack_public_path__ + "aa70057042488eef46660369434e99d4.png";